import { put, call, takeLatest } from "redux-saga/effects";
import sellerApi from "../../utils/sellerApi";
import {
    getTopsellingProductRequest,
    getTopsellingProductSuccess,
    getTopsellingProductFailure,
} from "./Analytics-slice"; 


function* getTopsellingProductSaga(action) {

  try {
    const response = yield sellerApi.get(`getTopSellingProducts`);
    yield put(getTopsellingProductSuccess(response.data));
  } catch (error) {
    yield put(getTopsellingProductFailure(error.message));
  }
}

export function* watchgetTopsellingProduct() {
  yield takeLatest(getTopsellingProductRequest.type, getTopsellingProductSaga);
}
